import request from "@/utils/request";
// import { getcpyNo } from "../utils/auth";
// 国家
export const countryApi=(data)=>{
    return request({
        url:"/api/country/queryCountry",
        method:"get",
        params:data
    })
}
// 省
export function provinceApi(data){
    return request({
        url:"/api/country/queryState",
        method:"get",
        params:data
    })
}
// 城市区域
export const cityApi=(data)=>{
    return request({
        url:"/api/country/queryCity",
        method:"get",
        params:data
    })
}
// 获取行业
export const definedQueryApi=(data)=>{
    return request({
        url:"/api/user/defined/query",
        method:"get",
        params:data
    })
}


// 获取行业列表
export const definedQueryListApi=(data)=>{
    return request({
        url:"/api/user/defined/queryList",
        method:"post",
        params:data
    })
}





